const TestQuestions = [
    {
        question:"1.Have you noticed any swelling or enlargement in your neck?",
        yes:"y1",
        no:"n1",
        key:40
    },
    {
        question:"2.Do you have unexplained weight loss/gain despite normal eating habits?",
        yes:"y2",
        no:"n2",
        key:41
    },
    {
        question:"3.Do you experience excessive sweating or heat intolerance?",
        yes:"y3",
        no:"n3",
        key:42
    },
    {
        question:"4.Have you experienced thinning or brittle hair recently?",
        yes:"y4",
        no:"n4",
        key:43
    },
    {
        question:"5.Do you have a rapid or irregular heartbeat?",
        yes:"y5",
        no:"n5",
        key:44
    },
    {
        question:"6.Do you often feel tired or fatigued?",
        yes:"y6",
        no:"n6",
        key:45
    },
    {
        question:"7.Have you noticed changes in your bowel habits, such as constipation or diarrhea?",
        yes:"y7",
        no:"n7",
        key:46
    },
    {
        question:"8.Do you have muscle weakness or joint pain?",
        yes:"y8",
        no:"n8",
        key:47
    },
    {
        question:"9.Do you experience frequent mood swings or irritability?",
        yes:"y9",
        no:"n9",
        key:48
    },
    {
        question:"10.Do you have difficulty concentrating or remembering things?",
        yes:"y10",
        no:"n10",
        key:49
    },
    {
        question:"11.Do you have dry skin or hair?",
        yes:"y11",
        no:"n11",
        key:50
    },
    {
        question:"12.Do you often feel cold, especially in your hands and feet?",
        yes:"y12",
        no:"n12",
        key:51
    },
    {
        question:"13.Have you experienced changes in your appetite?",
        yes:"y13",
        no:"n13",
        key:52
    },
    {
        question:"14.Have you had trouble sleeping or insomnia?",
        yes:"y14",
        no:"n14",
        key:53
    },
    {
        question:"15.Do you have a hoarse or raspy voice?",
        yes:"y15",
        no:"n15",
        key:54
    },
    {
        question:"16.Have you experienced swelling in your legs, ankles, or face?",
        yes:"y16",
        no:"n16",
        key:55
    }
]

export default TestQuestions;